import {observable, action} from 'mobx';

class VideoPopUpStore {

  @observable videoPopUp = false;
  @observable videoPopup = {
    isOpened: false,
    videoData: null
  };

  @action
  initPopUp = () => {
    this.videoPopUp = !this.videoPopUp;
  };

  @action
  addData = (object) => {
    this.videoPopupData = object;
  };
}

export default new VideoPopUpStore();




// WEBPACK FOOTER //
// ./src/stores/videoPopUpStore.js